
import { createSlice } from '@reduxjs/toolkit';
const initialState={
    openModal:false,
    loader:false,
    success:'',
    error:'',
    skeltonLoader:false,
    linearLoader:false,
    loading:false,
    // Number of in-flight requests that requested the loading state. `loading`
    // stays true until every one of them finishes, so overlapping requests
    // (e.g. rapid filter clicks) don't prematurely clear the spinner.
    loadingCount:0,
    forgotPasswordModal:false,
}
const commonSlice=createSlice({
    name:'common',
    initialState:initialState,
    reducers:{
    openModal:(state,action)=>{
    state.openModal=true;
    },
    closeModal:(state,action)=>{
    state.openModal=false;
    },
    openForgotPasswordModal:(state,action)=>{
        state.forgotPasswordModal=true;
        },
        closeForgotPasswordModal:(state,action)=>{
        state.forgotPasswordModal=false;
        },
    showError:(state,action)=>{
    state.error=action.payload;
    },
    closeError:(state,action)=>{
    state.error='';
    },
    showSuccess:(state,action)=>{
    state.success=action.payload;
    },
    closeSuccess:(state,action)=>{
    state.success='';
    },
    showSkelton:(state,action)=>{
    state.skeltonLoader=true;
    },
    closeSkelton:(state,action)=>{
    state.skeltonLoader=false;
    },
    showLoader:(state,action)=>{
        state.loader=true;
    },
    closeLoader:(state,action)=>{
        state.loader=false;
    },
    showLinearLoader:(state,action)=>{
        state.linearLoader=true;
    },
    closeLinearLoader:(state,action)=>{
        state.linearLoader=false;
    },
    showLoading:(state,action)=>{
        state.loadingCount += 1;
        state.loading=true;
    },
    closeLoading:(state,action)=>{
        state.loadingCount = Math.max(0, state.loadingCount - 1);
        state.loading = state.loadingCount > 0;
    }


    }
});

export const {
    openModal,closeModal,showError,closeError,
    showSuccess,closeSuccess,showSkelton,closeSkelton,
    showLoader,closeLoader,
    showLinearLoader,closeLinearLoader,showLoading,closeLoading,
    openForgotPasswordModal,closeForgotPasswordModal
} =commonSlice.actions;
export default commonSlice.reducer;

